import React from "react";
import Skeleton from "@mui/material/Skeleton";

/**
 * Shared Fleet Health card shell.
 * heading / subheading / badge / content stay consistent across widgets.
 */
const HealthCard = ({
  title,
  subtitle,
  badge,
  badgeStyle,
  headerAction,
  loading = false,
  className = "",
  children,
  footer,
  dark = false,
}) => {
  return (
    <div className={`fh-card ${dark ? "fh-camp" : ""} ${className}`.trim()}>
      <div className="fh-card-head">
        <div style={{ minWidth: 0 }}>
          <h3 className="fh-card-title">{title}</h3>
          {subtitle ? <div className="fh-card-sub">{subtitle}</div> : null}
        </div>
        {headerAction ? (
          <div className="fh-card-head-action">{headerAction}</div>
        ) : null}
        {badge ? (
          <span className="fh-badge" style={badgeStyle}>
            {badge}
          </span>
        ) : null}
      </div>

      <div className="fh-card-body">
        {loading ? (
          <div style={{ paddingTop: 8 }}>
            <Skeleton variant="rectangular" height={28} style={{ marginBottom: 10 }} />
            <Skeleton variant="rectangular" height={90} style={{ marginBottom: 10 }} />
            <Skeleton variant="rectangular" height={18} />
          </div>
        ) : (
          children
        )}
      </div>

      {footer ? <div className="fh-card-footer">{footer}</div> : null}
    </div>
  );
};

export default HealthCard;
